import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';
import type { TersaImageModel } from '../types';

// 系数
const COST_FACTOR = 1.5;

export const reveModels: Record<string, TersaImageModel> = {
    'reve-2.1': {
        chef: providers.reve,
        providers: [
            {
                ...providers.reve,
                model: undefined,
                model_create: wavespeed.image('reve/2.1/text-to-image'),
                model_edit: wavespeed.image('reve/2.1/edit'),
                getCost: () => {
                    return 0.28 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['4x1', '3x1', '21x9', '2x1', '17x9', '16x9', '3x2', '4x3', '5x4', '1x1', '4x5', '3x4', '2x3', '9x16', '1x2', '1x3', '1x4'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '4x1', '3x1', '21x9', '2x1', '17x9', '16x9', '3x2', '4x3', '5x4', '1x1', '4x5', '3x4', '2x3', '9x16', '1x2', '1x3', '1x4'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 8, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};
